import Badge from './badge.vue';
export default Badge;


// WEBPACK FOOTER //
// ./src/components/badge/index.js